import { createApp } from 'vue';
import App from '@/App.vue';

import { router } from '@/modules/router';
import * as User from '@/modules/user';

( async () =>
{
	await User.Recover();

	createApp( App )
		.use( router )
		.mount( '#app' );
} )();
